import { createVuetify } from "vuetify";

export default createVuetify();
